import type { ChatbotFileEvent } from '@/models/chatbot';
import { toSafeUrl } from '@/utils/toSafeUrl';

export const BYTES_PER_KILOBYTE = 1024;

const HTTPS_PROTOCOLS = ['https:'];

const IMAGE_FILENAME_PATTERN = /\.(svg|png|jpe?g|gif|webp|avif)$/i;

export const isImageFile = (file: Pick<ChatbotFileEvent, 'content_type' | 'filename'>): boolean => {
  if (file.content_type && file.content_type.startsWith('image/')) {
    return true;
  }

  return IMAGE_FILENAME_PATTERN.test(file.filename);
};

const MESSAGE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
});

export const isSafeUrl = (url: string): boolean =>
  toSafeUrl(url, { allowedProtocols: HTTPS_PROTOCOLS, allowProtocolInference: false }) !== null;

export const formatMessageTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return MESSAGE_TIME_FORMATTER.format(date);
};
